import Pc from "pages/pc";
const Tracking = ({ children }) => {
  const checkPc = () => {
    // if (process.env.REACT_APP_NODE_ENV === "qa") {
    //   if (window.innerWidth > 768) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // } else {
      if (navigator.maxTouchPoints > 1) {
        return false;
      } else {
        return true;
      }
    // }
  };
  if (checkPc()) {
    // @ts-ignore
    return <Pc />;
  } else {
    return children;
  }
};

export default Tracking;
